import React, { useState } from "react";
import {
  TableBody,
  TableRow,
  TableCell,
  Typography,
  Collapse,
  TableContainer,
  Paper,
} from "@mui/material";
import {
  GridContainer,
  HoldingsTableContainer,
  HoldingsTable,
  HoldingsTableRow,
  HoldingsExpandButton,
  HoldingsCollapseContent,
  HoldingsTableHeader,
} from "./PeriodicAcquirerReport.styles";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import moment from "moment";
import PeriodicAcquirerReportGroupsTable from "./PeriodicAcquirerReport.groupsTable";

function RenderHoldingsRow(props) {
  const { row } = props;
  const { date, holdings } = row;
  const [open, setOpen] = useState(false);

  const formatNumber = (value) => {
    if (typeof value === "string") {
      const num = parseFloat(value);
      return isNaN(num)
        ? value
        : num.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 4,
          });
    }
    return value?.toLocaleString("en-US") || "0";
  };

  const isPositiveAmount = (value) => {
    const num = parseFloat(value);
    return !isNaN(num) && num >= 0;
  };

  const groups = holdings?.groups?.group;
  const groupsList = Array.isArray(groups) ? groups : groups ? [groups] : [];

  return (
    <>
      <HoldingsTableRow isOpen={open}>
        <TableCell>
          <HoldingsExpandButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </HoldingsExpandButton>
        </TableCell>
        <TableCell
          align="center"
          sx={{ fontWeight: 600, fontSize: "0.875rem" }}
        >
          {holdings?.merchantHolding}
        </TableCell>
        <TableCell
          align="center"
          sx={{ fontWeight: 600, fontSize: "0.875rem" }}
        >
          {holdings?.merchantHoldingID}
        </TableCell>
        <TableCell
          align="center"
          sx={{ fontWeight: 600, fontSize: "0.875rem" }}
        >
          {moment(date, "YYYYMMDD").format("MM/DD/YYYY")}
        </TableCell>
        <TableCell
          align="center"
          sx={{ fontWeight: 600, fontSize: "0.875rem" }}
        >
          ${formatNumber(holdings?.transactionsAmount)}
        </TableCell>
        <TableCell
          align="center"
          sx={{ fontWeight: 600, fontSize: "0.875rem" }}
        >
          {holdings?.transactionsCount}
        </TableCell>
        <TableCell
          align="center"
          sx={{
            fontWeight: 700,
            fontSize: "0.875rem",
            color: isPositiveAmount(holdings?.amountDue)
              ? "success.main"
              : "error.main",
          }}
        >
          ${formatNumber(holdings?.amountDue)}
        </TableCell>
        <TableCell
          align="center"
          sx={{ fontWeight: 600, fontSize: "0.875rem" }}
        >
          ${formatNumber(holdings?.txMDR)}
        </TableCell>
        <TableCell
          align="center"
          sx={{ fontWeight: 600, fontSize: "0.875rem" }}
        >
          ${formatNumber(holdings?.txProcessing)}
        </TableCell>
      </HoldingsTableRow>
      <TableRow>
        <TableCell
          style={{ paddingLeft: 30, paddingBottom: 0, paddingTop: 0 }}
          colSpan={9}
        >
          <Collapse in={open} timeout="auto" unmountOnExit>
            <HoldingsCollapseContent>
              <PeriodicAcquirerReportGroupsTable groupsList={groupsList} />
            </HoldingsCollapseContent>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}

const HoldingsTableComponent = (props) => {
  const { holdingList } = props;

  const headers = [
    { label: "", align: "center" },
    { label: "Merchant Name", align: "center" },
    { label: "MID", align: "center" },
    { label: "Date", align: "center" },
    { label: "Amount", align: "center" },
    { label: "Trans. Count", align: "center" },
    { label: "Settlement", align: "center" },
    { label: "MDR Fee", align: "center" },
    { label: "Proc. Fee", align: "center" },
  ];

  const list = Array.isArray(holdingList) ? holdingList : [];

  return (
    <GridContainer>
      <HoldingsTableContainer sx={{ width: "100%" }}>
        <TableContainer component={Paper} elevation={0} sx={{ width: "100%" }}>
          <HoldingsTable size="small" sx={{ width: "100%" }}>
            <HoldingsTableHeader>
              <TableRow>
                {headers.map((header, index) => (
                  <TableCell
                    key={index}
                    align={header.align}
                    sx={{
                      fontWeight: 700,
                      fontSize: "0.875rem",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                      ...header.style,
                    }}
                  >
                    {header.label}
                  </TableCell>
                ))}
              </TableRow>
            </HoldingsTableHeader>
            <TableBody>
              {list.length > 0 ? (
                list.map((holding, index) => (
                  <RenderHoldingsRow
                    key={`${holding.date ?? index}-${index}`}
                    row={holding}
                  />
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={9} align="center" sx={{ py: 4 }}>
                    <Typography variant="body2" color="text.secondary">
                      No holding company data available
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </HoldingsTable>
        </TableContainer>
      </HoldingsTableContainer>
    </GridContainer>
  );
};

export default HoldingsTableComponent;
